import React from "react";
import styled from "styled-components";
import { Input, InputGroup } from "rsuite";
import SearchIcon from "@rsuite/icons/Search";
import { colors } from "../theme/colors";

const SearchField = ({
  placeholder = "Search...",
  value,
  onChange,
  className,
  ...props
}) => {
  return (
    <StyledInputGroup inside className={className} {...props}>
      <StyledInput
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      <InputGroup.Addon>
        <SearchIcon style={{ color: colors.neutral[500] }} />
      </InputGroup.Addon>
    </StyledInputGroup>
  );
};

const StyledInputGroup = styled(InputGroup)`
  width: 100%;
  border-radius: 25px;

  .rs-input-group-addon {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-left: none;
    border-radius: 0 50px 50px 0;
  }
`;

const StyledInput = styled(Input)`
  border-radius: 50px 0 0 50px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(8px);
  padding: 8px 20px !important;
  height: 38px !important;
  color: ${colors.neutral[800]} !important;

  &::placeholder {
    color: ${colors.neutral[500]} !important;
  }

  &:hover {
    border-color: rgba(255, 255, 255, 0.4) !important;
    background: rgba(255, 255, 255, 0.15) !important;
  }

  &:focus {
    border-color: ${colors.primary.main} !important;
    background: rgba(255, 255, 255, 0.2) !important;
    box-shadow: 0 0 0 2px rgba(44, 90, 160, 0.1) !important;
  }
`;

export default SearchField;
